module.exports = __webpack_public_path__ + "static/media/library.10dd03c7.svg";